// Shared management-team data — used by the About page and the landing page.
export const TEAM = [
  {
    name: "Ahmad Raza",
    role: "Chief Executive Officer",
    bio: "12+ years leading CloudLab from a design studio to a full-spectrum AI product company.",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_ai-solutions-lab-22/artifacts/xo9258w2_ChatGPT%20Image%20Jul%2026%2C%202026%2C%2011_36_01%20PM_compressed.webp",
  },
  {
    name: "Ayesha Rehman",
    role: "Operations Manager · Pakistan",
    bio: "Runs the Islamabad delivery hub and keeps every project shipping on time.",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_ai-solutions-lab-22/artifacts/jn644rn1_ChatGPT%20Image%20Jul%2026%2C%202026%2C%2011_08_34%20PM_compressed.webp",
  },
  {
    name: "Dr. Mahtab Alam",
    role: "AI & Communication",
    bio: "PhD-led applied-AI programs — from LLM copilots to voice agents in production.",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_ai-solutions-lab-22/artifacts/ym3w52qx_ChatGPT%20Image%20Jul%2026%2C%202026%2C%2011_23_05%20PM_compressed.webp",
  },
  {
    name: "Saif-ur-Rehman",
    role: "Cloud Infrastructure",
    bio: "Designs and operates AWS/Azure/GCP fleets with 99.9% uptime SLAs for our clients.",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_ai-solutions-lab-22/artifacts/d1labtz0_ChatGPT%20Image%20Jul%2026%2C%202026%2C%2011_34_08%20PM_compressed.webp",
  },
  {
    name: "Sophie Bennett",
    role: "Business Relations",
    bio: "Grows CloudLab's international partnerships across the UK, EU and North America.",
    photo:
      "https://customer-assets-jai6qajn.emergentagent.net/job_ai-solutions-lab-22/artifacts/z4w8fdjd_ChatGPT%20Image%20Jul%2031%2C%202026%2C%2001_34_00%20AM.png",
  },
];
